var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.album)?_c('div',{staticClass:"actionbar"},[_c('tags',{attrs:{"is-more-photos-section":_vm.isMorePhotosSection}}),(+_vm.album.show_sorting)?_c('sorting',{attrs:{"is-more-photos-section":_vm.isMorePhotosSection}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }